import { render } from "./CreateExpensesPage.vue?vue&type=template&id=9d4d0cac&ts=true"
import script from "./CreateExpensesPage.vue?vue&type=script&lang=ts"
export * from "./CreateExpensesPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__